<template>
  <span class="flex w-full flex-col gap-1">
    <span class="flex w-full items-center gap-2 text-sm">
      <span class="shrink-0 font-medium text-primary">№{{ item.id }}</span>
      <span class="min-w-0 flex-1 truncate font-medium text-[#3A3D44]">{{ item.label }}</span>
      <span
        v-if="item.status"
        class="shrink-0 rounded-md px-2 py-0.5 text-xs leading-[1.4]"
        :class="PUBLICATION_STATUS_CLASSES[item.status.tone]"
      >
        {{ item.status.text }}
      </span>
    </span>
    <span v-if="summary" class="truncate text-xs text-[#99ABBA]">{{ summary }}</span>
  </span>
</template>

<script setup lang="ts">
  import {
    getPublicationSummary,
    PUBLICATION_STATUS_CLASSES,
    type PublicationMention,
  } from "~/common/chatChannels";

  const props = defineProps<{ item: PublicationMention }>();

  const summary = computed(() => getPublicationSummary(props.item));
</script>
